import { render, staticRenderFns } from "./ContactCell.vue?vue&type=template&id=b315d460&scoped=true"
import script from "./ContactCell.vue?vue&type=script&lang=js"
export * from "./ContactCell.vue?vue&type=script&lang=js"
import style0 from "./ContactCell.vue?vue&type=style&index=0&id=b315d460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b315d460",
  null
  
)

export default component.exports